module.exports = __webpack_public_path__ + "media/images/web/favicon/apple-icon-120x120-3417bcf35e1d75eba0c7d345cfff6c0c.png";